import { GzRmIconsListWebComponent } from './component/GzRmIconsListWebComponent';

export { GzRmIconsListWebComponent };
